// Value-type icon for requirement lists: ChartLine (curve), Ruler (value or range), Rows3 (bands), ToggleLeft (boolean), Text (text).
import { ChartLineIcon, RulerIcon, Rows3Icon, TextIcon, ToggleLeftIcon, type LucideIcon } from "lucide-react";

import type { ValueType } from "@/api/__generated__";
import { cn } from "@/lib/cn";
import { VALUE_TYPE_LABELS } from "@/lib/labels";

const ICONS: Record<ValueType, LucideIcon> = {
  scalar: RulerIcon,
  range: RulerIcon,
  curve: ChartLineIcon,
  curve_family: ChartLineIcon,
  bands: Rows3Icon,
  boolean: ToggleLeftIcon,
  text: TextIcon,
};

interface ValueTypeIconProps {
  valueType: ValueType;
  size?: number;
  labelled?: boolean;
  className?: string;
}

export function ValueTypeIcon({ valueType, size = 17, labelled = false, className }: ValueTypeIconProps) {
  const Icon = ICONS[valueType];
  return (
    <Icon
      width={size}
      height={size}
      className={cn("shrink-0 text-b2", className)}
      {...(labelled ? { role: "img", "aria-label": VALUE_TYPE_LABELS[valueType] } : { "aria-hidden": true })}
    />
  );
}
